import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { useDispatch } from 'react-redux'
import { createSetIsToastOpen } from 'src/app/Toast/redux/toast.actions'
import {
  ConnectToAmericanExpressBankFeedSuccessMessage,
  DisconnectFromAmericanExpressBankFeedSuccessMessage,
} from 'src/app/Toast/Toast'
import { OrganizationsListResponse } from 'src/models/organizations.models'
import { orgQueryKeys } from 'src/queries/queries.constants'
import { MutationMethod, useExtendMutation } from 'src/queries/queries.utils'
import {
  GET_ORGANIZATION_FAILURE,
  GET_ORGANIZATION_INIT,
  GET_ORGANIZATION_SUCCESS,
} from 'src/redux/actions/data/organizations.actions'

interface PutOrgPhysicalClearingsEnabledRequest {
  enabled: boolean
}

interface UsePutOrgPhysicalClearingsEnabledRequest {
  id: string
  body: PutOrgPhysicalClearingsEnabledRequest
}

export const usePutOrgPhysicalClearingsEnabled = (orgId: string) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useExtendMutation<
    OrganizationsListResponse,
    UsePutOrgPhysicalClearingsEnabledRequest
  >(MutationMethod.PUT, {
    mutationUrl: ({ id }) => `/organizations/${id}/physicalclearings`,
    reduxInitAction: { type: GET_ORGANIZATION_INIT },
    onSuccess: (data) => {
      dispatch({
        type: GET_ORGANIZATION_SUCCESS,
        payload: { organization: data },
      })
      dispatch(
        createSetIsToastOpen(true, {
          toastMessage: data.physicalClearingsEnabled ? (
            <ConnectToAmericanExpressBankFeedSuccessMessage />
          ) : (
            <DisconnectFromAmericanExpressBankFeedSuccessMessage />
          ),
        }),
      )
      queryClient.invalidateQueries({
        queryKey: [orgQueryKeys.physicalClearings(orgId)],
      })
    },
    onError: (error) => {
      dispatch({ type: GET_ORGANIZATION_FAILURE, payload: error })
    },
  })
}
